import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { useHideAddToCart } from '../useHideAddToCart'

import { ProductBuyBoxDeliveryStatusInfoBox } from './ProductBuyBoxDeliveryStatusInfoBox'
import { ProductBuyBoxMpDeliveryInfo } from './ProductBuyBoxMpDeliveryInfo'
import { ProductBuyBoxSellerInfo } from './ProductBuyBoxSellerInfo'

export const ProductBuyBoxStockStatusAndDeliveryInfo: FC = () => {
  const { attributeSelectionControls } = useProductPageContext()
  const hideAddToCart = useHideAddToCart()
  const { currentPrescriptionType, offerId, product } = useProductPageContext()

  /**
   * We need to know if the offer is a partner's offer or an SAE offer.
   */
  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  const { hasUnselectedAttributes, noAttributeSelectedError } =
    attributeSelectionControls.attributeNotSelectedErrorControls
  const noCombinationError =
    !noAttributeSelectedError &&
    attributeSelectionControls.variantMatchingSelection === undefined
  const hasErrors = noAttributeSelectedError || noCombinationError
  /**
   * when user has any unselected attribute, but did not yet click add to cart we show normal message "please select attribute"
   * when user clicked on add to cart and if he has unselected attrs, we show same message but as error
   */
  const showSelectAttributeMessage = !hasErrors && hasUnselectedAttributes
  const showDeliveryStatus = !hasErrors && !showSelectAttributeMessage

  if (hideAddToCart) {
    return null
  }

  return (
    <div
      className={clsx(
        'my-2.5 flex items-start justify-between',
        isOfferMirakl && 'w-full flex-col',
        showDeliveryStatus && 'flex-row',
      )}
    >
      {noAttributeSelectedError ? (
        <p className="font-medium text-dark-error">
          <FormattedMessage id="variantAttributes.message.configureProduct" />
        </p>
      ) : null}
      {noCombinationError ? (
        <p className="font-medium text-dark-note">
          <FormattedMessage id="variantAttributes.message.notPossible" />
        </p>
      ) : null}
      {showSelectAttributeMessage ? (
        <p className="font-bold">
          <FormattedMessage id="variantAttributes.message.configureProduct" />
        </p>
      ) : null}

      {isOfferMirakl ? (
        <>
          <ProductBuyBoxSellerInfo key={product.upid} />
          <ProductBuyBoxMpDeliveryInfo />
        </>
      ) : null}

      {showDeliveryStatus && !isOfferMirakl ? (
        <ProductBuyBoxDeliveryStatusInfoBox />
      ) : null}
    </div>
  )
}
